<template>
  <div class="list">
    <div class="title">流程处理人</div>
    <div class="Steps">
      <el-steps :active="currentIndex">
        <el-step v-for="(item, index) in nodeList" :key="index" :title="item.flowDefinitionName"
          :description="item.nodeName" @click.native="clickNodeDetail(index, item)"></el-step>
      </el-steps>
      <div class="stepRight">
        <div class="step_type">
          <span style="margin-right: 20px">审批人</span>
          <addBtn v-if="allowChangeAssigneeList(nodeDetail)" @click="addApproveUser(nodeDetail)" />
        </div>
        <div class="userList">
          <span v-for="(res, index) in nodeDetail.assigneeList" :key="index" class="user_class">
            <userItem :user="res" :can-delete="allowChangeAssigneeList(nodeDetail)"
              @delete="deleteApproveUser(index, nodeDetail.assigneeList)" />
          </span>
        </div>
        <div v-if="!nodeDetail.assigneeList || !nodeDetail.assigneeList.length" class="userList">
          无审批人
        </div>
        <div class="step_type">
          <span style="margin-right: 20px">抄送人</span>
        </div>
        <div class="userList">
          <userItem v-for="(res, index) in nodeDetail.ccList" :key="index" :user="res" :can-delete="res.newValue == 1"
            :custom-params="nodeDetail.ccList" style="margin-right: 20px" @delete="handleDeleteUserFromList" />
          <addBtn v-if="nodeDetail.ccOptional === 1" @click="addCCUser(nodeDetail)" />
        </div>
        <div v-if="!nodeDetail.ccList || !nodeDetail.ccList.length" class="userList">
          无抄送人
        </div>
      </div>
    </div>
    <component :is="userSelectDlg" ref="userSelectDlg" :can-select-system-role="false" :can-select-project-role="false"
      :custom-com-params="customComParams" :select-list="nodeDetail.assigneeList || []"
      @userSelected="handleUserSelected" />
    <div class="footer">
      流程完成后抄送人：
    </div>
    <div class="footer">
      <div v-if="!flowCcList || !flowCcList.length" class="userList">
        无抄送人
      </div>
      <userList v-model="flowCcList" :can-edit="true" :use-custom-user-selector="useCustomCcUserSelector"
        :user-selection-params="ccUserSelectionParams" />
      <!-- {{flowCcList -->
    </div>
  </div>
</template>
<script>
const APPROVE_USER = 0;
const CC_USER = 1;
import { mapState } from "vuex";
import personChoose from "./personChoose.vue";
import { gettouxAvatar } from "@/CommonDP/utils";
import flowService from "@/CommonDP/service/flow-service";
import { getUserSelectDlg } from "../flowFormRegister";
import userItem from "./userItem";
import userList from "./userList";
import addBtn from "./addBtn";

export default {
  components: { personChoose, userItem, userList, addBtn },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    // 流程编码， flowDefinitionVersionId， flowDefinitionId 三者不可同时为空
    flowKey: {
      type: String,
      default: ""
    },

    // 流程定义id
    flowDefinitionId: {
      type: String,
      default: ""
    },
    // 流程版本号
    flowVersionId: {
      type: String,
      default: ""
    },
    customComParams: {
      type: Object,
      default: () => {}
    },
    useCustomCcUserSelector: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      nodeList: [],
      currentNode: null,
      showAddApproveUser: true,
      currentIndex: 0,
      nodeDetail: {},
      nodeParams: {},
      // 默认使用内部的选人组件
      userSelectDlg: "personChoose",
      // 流程完成后抄送人
      flowCcList: [],
      selectPeopleType: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerParams: (state) => state.projectMg.routerParams
    }),
    ccUserSelectionParams() {
      return {
        canSelectSystemRole: false,
        canSelectProjectRole: false
      };
    }
  },
  created() {
    if (this.routerParams.flowKey === "plan_review" || this.routerParams.flowKey === "spec_review" || this.routerParams.flowKey === "comprehensive_review") {
      this.showAddApproveUser = false;
    }
  },
  mounted() {
    this.queryFlowDefCcUsers();
  },
  methods: {
    expose_getCCUserIdList() {
      return this.flowCcList.map((item) => item.userId);
    },
    async queryCCUserIdList() {
      const res = await flowService.queryCCUserIdList(this.routerParams.flowInstanceId);
      this.flowCcList = res.data;
    },
    allowChangeAssigneeList(nodeDetail) {
      if (this.currentIndex <= 0) {
        return false;
      }
      // 有2种情况允许增加人。1. 允许动态添加审批人；2. 选人策略人申请人自选
      return nodeDetail.allowAddApproverDynamic || nodeDetail.assigneeSelectionStrategy === "2";
    },

    // 接口：查询节点及处理人。formData 不能为空，prjId 可以为空
    async queryFlowNodes(formData, prjId) {
      if (!this.flowKey && !this.flowDefinitionId) {
        this.$error("flowKey 与 flowDefinitionId 必需指定一个");
        return false;
      }
      console.debug("formData, ", formData);
      const queryParam = {
        flowDefinitionVersionId: this.flowVersionId,
        flowDefinitionId: this.flowDefinitionId,
        flowKey: formData.flowKey || this.flowKey,
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId,
        prjId: prjId,
        param: { ...formData, prjId, enterpriseId: this.routerParams.enterpriseId || this.enterpriseId }
      };
      let res;
      try {
        res = await flowService.queryFlowNodeList(queryParam);
        this.setNodeList(res.data || []);
        return !!res.data && res.data.length > 0;
      } catch (e) {
        this.$message.warning("未找到流程信息，请创建流程");
        return !!res.data && res.data.length > 0;
      }
    },

    // 接口：获取节点和他的处理人信息
    getFlowNodeWithAddedUsers() {
      return this.nodeList.map((node) => {
        const userDtoList = [...node.assigneeList, ...node.addedApproveUserList, ...node.addedCCUserList];
        return { flowNodeDefinitionId: node.flowNodeDefinitionId, userDtoList };
      });
    },

    // 接口：设置流程节点和节点的处理人
    setNodeList(nodeList) {
      this.nodeDetail = {};
      let sortNum = 1;
      nodeList.forEach((node) => {
        node.addedApproveUserList = [];
        node.addedCCUserList = [];
        node.sortNum = sortNum++;

        // 三个评审表单为前提
        if (!this.showAddApproveUser) {
          if (node.flowDefinitionName === "专业负责人") {
            node.assigneeList = this.getAssigneeUserName(this.nodeParams.specManagerList, node.flowNodeDefinitionId);
          } else if (node.flowDefinitionName === "项目经理") {
            node.assigneeList = this.getAssigneeUserName(this.nodeParams.prjManagerList, node.flowNodeDefinitionId);
          } else if (node.flowDefinitionName === "项目总负责人") {
            node.assigneeList = this.getAssigneeUserName(this.nodeParams.prjGeneralManagerList, node.flowNodeDefinitionId);
          } else if (node.flowDefinitionName === "专业审定人") {
            node.assigneeList = this.getAssigneeUserName(this.nodeParams.approvedUserList, node.flowNodeDefinitionId);
          }
        }
        node.assigneeList.forEach((node) => {
          const img = gettouxAvatar(node.userId);
          if (img) {
            node.img = img;
          } else {
            node.tox = node.name.charAt(0);
          }
        });
        node.ccList.forEach((node) => {
          const img = gettouxAvatar(node.userId);
          if (img) {
            node.img = img;
          } else {
            node.tox = node.name.charAt(0);
          }
        });
      });
      this.nodeList = nodeList;
      if (nodeList.length > 0) {
        this.currentIndex = 0;
        this.nodeDetail = nodeList[0];
      }
    },
    // 接口：设置节点的参数, 无用
    setNodeParams(nodeParams) {
      this.nodeParams = nodeParams;
    },

    // 接口：校验数据
    async validate() {
      return true;
    },

    // 接口：为特定节点设置处理人
    async selectApplicant(nodeDefinitionId) {
      const node = this.nodeList.find((item) => item.flowNodeDefinitionId === nodeDefinitionId);
      if (!node) {
        this.$error("找不到节点：" + nodeDefinitionId);
        return;
      }
      await this.$confirm("要继续，需要对节点：" + node.nodeName + " 设置处理人，继续吗？");
      this.openUserSelectDlg(node, 0);
    },

    async openUserSelectDlg(node, type) {
      let com = null;
      if (type === 0 || this.useCustomCcUserSelector) {
        com = getUserSelectDlg();
      }
      if (com) {
        this.userSelectDlg = com;
      } else {
        this.userSelectDlg = "personChoose";
      }
      await this.$nextTick();
      const title = this.getChoosePeopleTitle(node, type);
      this.$refs.userSelectDlg.show(title, { type: type, node: node });
    },

    getChoosePeopleTitle(node, type) {
      return "设置节点 " + node.nodeName + (type === 0 ? " 的处理人" : " 的抄送人");
    },

    clickNodeDetail(index, node) {
      this.currentIndex = index;
      this.nodeDetail = node;
    },

    getAssigneeUserName(nameList, flowNodeDefinitionId) {
      nameList.forEach((ele) => {
        ele.userName = ele.name;
        ele.type = APPROVE_USER;
        ele.flowNodeDefinitionId = flowNodeDefinitionId;
      });
      return nameList;
    },
    // 添加人员弹框
    addApproveUser(node) {
      this.currentNode = node;
      this.openUserSelectDlg(node, 0);
      this.selectPeopleType = "assigneeList";
    },

    addCCUser(node) {
      this.currentNode = node;
      this.openUserSelectDlg(node, 1);
      this.selectPeopleType = "ccList";
    },

    // 删除审批人
    deleteApproveUser(index, list) {
      list.splice(index, 1);
    },

    handleUserSelected(list, type, params) {
      if (type === 0) {
        if (params && params.node) {
          // 指定的节点（一般是下一个节点）
          this.addSpecifiedNodeApproveUser(list, params.node);
        } else {
          // 当前节点
          this.AddApproveUserToCurrentNode(list);
        }
      } else {
        this.AddCCUserToCurrentNode(list);
      }
    },

    AddApproveUserToCurrentNode(userList) {
      const assigneeList = this.currentNode.assigneeList || [];
      const addedApproveUserList = this.currentNode.addedApproveUserList || [];
      for (const item of userList) {
        const canAddUser = this.canAddUser(item, assigneeList);
        if (canAddUser) {
          const newUser = {
            flowNodeDefinitionId: this.currentNode.flowNodeDefinitionId,
            userId: item.userId,
            type: APPROVE_USER,
            userName: item.name,
            newValue: 1,
            img: gettouxAvatar(item.userId),
            tox: item.name.charAt(0)
          };
          assigneeList.push(newUser);
          addedApproveUserList.push(newUser);
        }
      }
      this.currentNode.assigneeList = assigneeList;
      this.currentNode.addedApproveUserList = addedApproveUserList;
    },

    canAddUser(user, assigneeList) {
      const found = assigneeList.find((item) => item.userId === user.userId);
      if (found) {
        return false;
      }
      return true;
    },

    // 为特定的节点设置节点审批人
    addSpecifiedNodeApproveUser(userList, node) {
      if (!userList || !userList.length) {
        this.$error("没有选择任何人");
        return;
      }
      if (!node) {
        this.$error("参数错误，无节点信息");
        return;
      }
      console.debug("为节点：", node.nodeName, "设置审批人：", userList);
      const assigneeList = [];
      for (const item of userList) {
        const newUser = {
          flowNodeDefinitionId: node.flowNodeDefinitionId,
          userId: item.userId,
          type: APPROVE_USER,
          userName: item.name,
          newValue: 1,
          img: gettouxAvatar(item.userId),
          tox: item.name.charAt(0)
        };
        assigneeList.push(newUser);
      }
      console.log(assigneeList, "assigneeList");
      node.assigneeList = assigneeList;
    },

    AddCCUserToCurrentNode(userList) {
      const ccList = this.currentNode.ccList || [];
      const addedCCUserList = this.currentNode.addedCCUserList || [];
      for (const item of userList) {
        const canAddUser = this.canAddUser(item, ccList);
        if (canAddUser) {
          const newUser = {
            flowNodeDefinitionId: this.currentNode.flowNodeDefinitionId,
            userId: item.userId,
            type: CC_USER,
            userName: item.name,
            newValue: 1,
            img: gettouxAvatar(item.userId),
            tox: item.name.charAt(0)
          };
          ccList.push(newUser);
          addedCCUserList.push(newUser);
        }
      }
    },

    handleDeleteUserFromList(user, list) {
      const index = list.findIndex((item) => item.userId === user.userId);
      const index2 = this.currentNode.addedCCUserList.findIndex((item) => item.userId === user.userId);
      if (index >= 0) {
        list.splice(index, 1);
        this.currentNode.addedCCUserList.splice(index2, 1);
      }
    },

    async queryFlowDefCcUsers() {
      if (this.readonly) {
        return;
      }
      const res = await flowService.queryFlowDefCcList(this.flowDefinitionId, this.flowKey);
      const data = res.data || [];
      data.forEach((item) => (item.disableDelete = 1));
      this.flowCcList = data;
    },
    // 校验 节点有无审批人
    // 流程发起时 校验下除第一个节点的其他节点有无审批人
    checkNodeList_AssigneeList() {
      const params = {
        nodeIndexes: "",
        nodeNames: "",
        flag: true
      };
      const nodeIndexes = [];
      const nodeNames = [];
      this.nodeList.forEach((ele, index) => {
        if (index !== 0 && !ele.assigneeList.length) {
          nodeIndexes.push(ele.sortNum);
          nodeNames.push(ele.nodeName);
          params.flag = false;
        }
      });
      if (!params.flag) {
        params.nodeIndexes = nodeIndexes.join(", ") ;
        params.nodeNames = "【" + nodeNames.join("】, 【") + "】";
      }
      return params;
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
  overflow-x: hidden;

  .title {
    box-sizing: border-box;
    height: 45px;
    padding-left: 20px;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 16px;
    line-height: 45px;
    color: var(--theme-color);
    border-bottom: 1px solid #ebefff;
  }

  .check {
    height: 45px;
    width: 100%;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .personList {
    width: 100%;
    padding: 10px;
    overflow-x: hidden;
  }
}

.userList {
  padding-left: 10px;
}

.footer {
  // display: flex;
  // align-items: center;
  margin-left: 90px;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 16px;
  line-height: 23px;
  color: var(--theme-color);

  .footer_addbtn {
    margin-left: 15px;
  }

  .userList {
    color: #000000;
  }
}

.user_class {
  margin-top: 5px;
  margin-right: 15px;
  position: relative;
  width: 100%;
  display: inline;

  span {
    margin-right: 4px;
  }
}

.Steps {
  padding: 20px 90px 20px 90px;
  width: 100%;
  box-sizing: border-box;

  /deep/ .el-steps {
    width: 100%;
  }

  /deep/ .el-step {
    &__description {
      margin-top: 2px;
    }

    &__head.is-finish {
      color: #c0c4cc;
      border-color: #c0c4cc;
    }

    &__title.is-finish,
    &__description.is-finish {
      color: #c0c4cc;
      cursor: pointer;
    }

    &__head.is-process {
      color: #346ffa;
      border-color: #346ffa;
    }

    &__icon.is-text {
      cursor: pointer;
    }

    &__description.is-process,
    &__title.is-process {
      color: #000000;
      font-weight: normal;
    }
  }

  .stepRight {
    .step_type {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      span {
        font-size: 16px;
        line-height: 23px;
        color: var(--theme-color);
      }
    }

    padding-top: 10px;
    width: 100%;
  }
}

.stepBottom {
  .step_type {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    span {
      font-size: 16px;
      line-height: 23px;
      color: var(--theme-color);
    }
  }

  padding: 0px 90px 20px 90px;
  width: 100%;
  // padding-top: 10px;
}

.hand {
  cursor: pointer;
}

.avatortox {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  line-height: 32px;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #4777e7;
  background: #4777e7;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}

.userAvator {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 0 auto;
  margin-top: 0px;
  display: inline-block;
  vertical-align: top;
}

.el-icon-error {
  left: 20px;
  color: red;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
}
</style>
